"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AssessmentList = function AssessmentList(_ref) {
  var _ref$assessments = _ref.assessments,
    assessments = _ref$assessments === void 0 ? [] : _ref$assessments;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var collapsibleRef = (0, _react.useRef)(null);
  var toggleButtonRef = (0, _react.useRef)(null);
  if (!Array.isArray(assessments) || assessments.length === 0) {
    return null;
  }
  if (assessments.length === 1) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].assessmentList
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].assessmentItem
    }, assessments[0]));
  }
  var firstAssessment = assessments[0];
  var remainingAssessments = assessments.slice(1);
  var remainingCount = remainingAssessments.length;
  var handleToggle = function handleToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    var newExpandedState = !isExpanded;
    setIsExpanded(newExpandedState);
  };
  (0, _react.useEffect)(function () {
    if (!isExpanded && toggleButtonRef.current) {
      toggleButtonRef.current.focus();
    }
  }, [isExpanded]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].assessmentList
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].assessmentItem
  }, firstAssessment), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: collapsibleRef,
    id: "collapsedAssessments",
    className: "".concat(_style["default"].assessmentCollapsible, " ").concat(isExpanded ? _style["default"].assessmentCollapsibleExpanded : ''),
    "aria-labelledby": "assessmentsToggleButton",
    "aria-hidden": !isExpanded
  }, /*#__PURE__*/_react["default"].createElement("div", null, remainingAssessments.map(function (assessment, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: _style["default"].assessmentItem,
      role: "listitem"
    }, assessment);
  }))), /*#__PURE__*/_react["default"].createElement("button", {
    ref: toggleButtonRef,
    id: "assessmentsToggleButton",
    className: "btn btn-secondary btn-sm",
    onClick: handleToggle,
    "aria-expanded": isExpanded,
    "aria-controls": "collapsedAssessments",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement("span", null, isExpanded ? 'hide' : "and ".concat(remainingCount, " more assessment").concat(remainingCount !== 1 ? 's' : '', " - show")))));
};
AssessmentList.propTypes = {
  assessments: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
AssessmentList.defaultProps = {
  assessments: []
};
var _default = exports["default"] = AssessmentList;